import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function WebhookPromptNode({ id, data }) {
    return (
        <NodeComponent title="Webhook" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

